import React from 'react';
import { useNavigate } from 'react-router-dom'; // Using useNavigate for navigation
import Navbar from '../components/Navbar'; // Adjust the path as needed
import '../styles/CAD.css';

const CloudConsulting = () => {
    const navigate = useNavigate();

    // For demonstration, the Learn More buttons redirect to Google.
    // Replace this with your actual navigation logic or paths.
    const handleNavigation = () => {
        window.location.href = "/contact";
    };

    return (
        <>
            <Navbar />
            <div className="custom-app-development">
                <div className="content-box">
                    <header className="header">
                        <h1>Cloud Consulting</h1>
                        <p className="tagline">
                            Elevate your cloud strategy with expert insights that optimize performance and reduce costs.
                        </p>
                    </header>
                    
                    <section className="introduction">
                        <p>
                            In today’s dynamic digital landscape, a robust cloud strategy is essential for agility and growth. Our Cloud Consulting services empower your organization to harness the full potential of cloud computing, transforming your IT infrastructure to be scalable, efficient, and cost-effective.
                        </p>
                    </section>
                    
                    <section className="why-choose-us">
                        <h2>Why Choose Our Cloud Consulting?</h2>
                        <p>
                            Our team of cloud experts brings years of experience in cloud architecture, migration, and optimization. We tailor our solutions to your business needs, ensuring seamless integration, enhanced performance, and sustainable cost savings. Let us guide your journey to a smarter, more secure cloud environment.
                        </p>
                    </section>
                    
                    <section className="tech-stack">
                        <h2>Our Approach & Methodology</h2>
                        <p>
                            We follow a comprehensive, end-to-end process to elevate your cloud strategy:
                        </p>
                        <ul>
                            <li><strong>Cloud Strategy & Planning:</strong> Detailed assessments and roadmap creation aligned with your business goals.</li>
                            <li><strong>Cloud Migration:</strong> Seamless transition of workloads to the cloud with minimal disruption.</li>
                            <li><strong>Cloud Optimization:</strong> Continuous performance tuning and cost management for your cloud environment.</li>
                            <li><strong>Cloud Security & Compliance:</strong> Implementing robust security measures to safeguard your digital assets.</li>
                        </ul>
                    </section>
                    
                    <section className="secure-practices">
                        <h2>Secure & Scalable Solutions</h2>
                        <p>
                            We ensure that your cloud infrastructure is not only optimized for performance and cost-efficiency but also fortified with the highest standards of security and compliance. Our proactive approach keeps your environment resilient against emerging threats.
                        </p>
                    </section>
                    
                    <section className="services">
                        <h2>Our Cloud Services</h2>
                        <div className="service-container">
                            <div className="service-box">
                                <h3>Cloud Strategy & Planning</h3>
                                <p>
                                    Develop a customized roadmap that aligns your business objectives with cutting-edge cloud solutions.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Cloud Migration</h3>
                                <p>
                                    Seamlessly transition your on-premises workloads to the cloud with minimal disruption.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Cloud Optimization</h3>
                                <p>
                                    Enhance the performance of your cloud infrastructure while reducing operational costs.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Cloud Security & Compliance</h3>
                                <p>
                                    Implement industry-leading security measures to protect your cloud assets and ensure regulatory compliance.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default CloudConsulting;
